import type { models } from 'cesg-shared';
import { fortnoxHttpService } from '../standard/http-service';

interface VoucherBodySchema {
  invoiceId: string;
}

class VoucherService {
  async createVoucher(
    invoiceId: string,
  ): Promise<models.GetSupplierInvoiceVoucher> {
    const body: VoucherBodySchema = {
      invoiceId: invoiceId,
    };
    const result = await fortnoxHttpService.request
      .url(`/voucher/bookkeep`)
      .post(body)
      .json<models.GetSupplierInvoiceVoucher>();
    return result;
  }
  async removeVoucher(
    invoiceId: string,
  ): Promise<models.GetSupplierInvoiceVoucher> {
    const body: VoucherBodySchema = {
      invoiceId: invoiceId,
    };
    const result = await fortnoxHttpService.request
      .url(`/voucher/unbookkeep`)
      .post(body)
      .json<models.GetSupplierInvoiceVoucher>();
    return result;
  }
}

export const voucherService = new VoucherService();
